<template>
  <div>
    <div v-bind:class="{'alert_msg': true, 'active' : message}">
      <div class="alert_msg_icon">
        <img :src="$designResource.iconClock" alt>
      </div>
      <div class="alert_msg_text">{{message}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      message: ""
    };
  },
  created: function() {
    var _this = this;
    window.addEventListener("alertMessage", function(e) {
      _this.message = e.detail;
      _this.$forceUpdate();
      setTimeout(() => {
        _this.message = "";
        _this.$forceUpdate();
        _this.$emit("hideMessage");
      }, 1500);
    });
  },
  methods: {
    fireEvent: function(evtType) {
      var ev = new Event(evtType);
      window.dispatchEvent(ev);
    }
  }
};
</script>

<style lang="scss">
.alert_msg {
  position: absolute;
  top: calc(50% - 63px);
  left: calc(50% - 115px);
  width: 230px;
  height: 126px;
  display: none;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
  z-index: 200;
}

.alert_msg.active {
  display: flex;
}

.alert_msg_icon {
  width: 40px;
}

.alert_msg_icon > img {
  width: 40px;
}

.alert_msg_text {
  color: #fff;
}
</style>